export default __webpack_public_path__ + "static/media/chat-icon5-restricted.ea5884a1.svg";